'use client'

interface ChatTransferNoticeProps {
  locale: string
  onAgree: () => void
}

export function ChatTransferNotice({ locale, onAgree }: ChatTransferNoticeProps) {
  const en = locale === 'en'
  return (
    <div
      className="mb-2 flex flex-col gap-2 text-[12px] leading-snug text-neutral-600 dark:text-white/70 sm:flex-row sm:items-center"
      data-testid="chat-transfer-notice"
    >
      <p className="m-0 flex-1">
        {en ? (
          <>Your messages are sent to OpenCode (AI model DeepSeek) in Singapore to answer them. See our </>
        ) : (
          <>Ihre Nachrichten werden zur Beantwortung an OpenCode (KI-Modell DeepSeek) in Singapur übermittelt. Mehr in der </>
        )}
        <a
          href={`/${en ? 'en' : 'de'}/datenschutz`}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-[var(--neon-orange)] underline underline-offset-2"
        >
          {en ? 'privacy policy' : 'Datenschutzerklärung'}
        </a>
        .
      </p>
      <button
        type="button"
        onClick={onAgree}
        className="shrink-0 cursor-pointer rounded-full border-none bg-[var(--neon-orange)] px-3 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-wider text-black transition-opacity hover:opacity-90"
      >
        {en ? 'I agree' : 'Einverstanden'}
      </button>
    </div>
  )
}
